import React from 'react';
import {
  Popover,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { ALL_CUSTOMER_STATUSES, CRM_LABELS } from '../models/Client';

const ClientStatusFilterPopover = ({
  open,
  anchorEl,
  onClose,
  selectedStatuses,
  onToggleStatus,
  onSelectAll,
  onClearAll,
  allSelected,
  anySelected,
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    PaperProps={{ sx: { mt: 0.5 } }}
  >
    <Box sx={{ p: 2, minWidth: 300, maxWidth: 380 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Status
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Button
            size="small"
            onClick={onClearAll}
            disabled={!anySelected}
            sx={{ textTransform: 'none' }}
          >
            Wyczyść filtr
          </Button>
          <Button
            size="small"
            onClick={onSelectAll}
            disabled={allSelected}
            sx={{ textTransform: 'none' }}
          >
            Wszystkie
          </Button>
        </Box>
      </Box>
      <List dense disablePadding sx={{ maxHeight: 360, overflow: 'auto' }}>
        {ALL_CUSTOMER_STATUSES.map((status) => (
          <ListItem key={status} disablePadding sx={{ py: 0 }}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={selectedStatuses.has(status)}
                  onChange={() => onToggleStatus(status)}
                />
              }
              label={
                <Typography variant="body2">
                  {CRM_LABELS.STATUS_LABELS[status]}
                </Typography>
              }
              sx={{ width: '100%', m: 0, py: 0.25, px: 0.5 }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  </Popover>
);

export default ClientStatusFilterPopover;
